import { CompanyInventoryItem, CompanyInventoryMaster, formatInventoryQty } from '../types/companyInventory';

/** 드롭다운용: 품명 마스터별로 SKU를 묶은 옵션 */
export function groupInventoryByMaster(
  items: CompanyInventoryItem[],
  masters?: CompanyInventoryMaster[]
): { masterId: number | null; itemName: string; itemKind: string; specs: CompanyInventoryItem[] }[] {
  const byMaster = new Map<
    string,
    { masterId: number | null; itemName: string; itemKind: string; specs: CompanyInventoryItem[] }
  >();

  if (masters && masters.length > 0) {
    for (const master of masters) {
      const key = `m-${master.masterId}`;
      byMaster.set(key, {
        masterId: master.masterId,
        itemName: master.itemName,
        itemKind: String(master.itemKind),
        specs: [...(master.items ?? [])],
      });
    }
  }

  for (const item of items) {
    const key =
      item.masterId != null
        ? `m-${item.masterId}`
        : `n-${item.itemKind}|${item.itemName}`;
    let group = byMaster.get(key);
    if (!group) {
      group = {
        masterId: item.masterId ?? null,
        itemName: item.itemName,
        itemKind: String(item.itemKind),
        specs: [],
      };
      byMaster.set(key, group);
    }
    if (!group.specs.some((s) => s.inventoryId === item.inventoryId)) {
      group.specs.push(item);
    }
  }

  return Array.from(byMaster.values()).sort((a, b) => {
    const kind = a.itemKind.localeCompare(b.itemKind);
    if (kind !== 0) return kind;
    return a.itemName.localeCompare(b.itemName, 'ko');
  });
}

export function inventorySpecLabel(item: Pick<CompanyInventoryItem, 'specText' | 'stockQty' | 'unit'>) {
  const spec = item.specText?.trim() || '기본';
  const stock = formatInventoryQty(item.stockQty);
  const unit = item.unit?.trim() ? ` ${item.unit.trim()}` : '';
  return `${spec} · 재고 ${stock}${unit}`;
}

export function inventoryOptionLabel(item: CompanyInventoryItem) {
  const spec = item.specText?.trim();
  return spec ? `${item.itemName} · ${spec}` : item.itemName;
}
